import { Box, Button, Group, Input, rem, Select } from "@mantine/core";
import { DateInput, DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  IconBarcode,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
} from "@tabler/icons-react";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  baseTheme,
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { SelectListItemModel } from "../../../model/SelectListItem";

import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import {
  AllCommunityModule,
  ColDef,
  DefaultMenuItem,
  GetContextMenuItemsParams,
  GridReadyEvent,
  MenuItemDef,
  RowSelectionOptions,
  StatusPanelDef,
} from "ag-grid-community";
import { ClientSideRowModelModule, ModuleRegistry } from "ag-grid-enterprise";
import type { CustomCellRendererProps } from "ag-grid-react";
import { AgGridReact } from "ag-grid-react";
import { useParams, useSearchParams } from "react-router-dom";
import { MessageResponse } from "../../../model/MessageResponse";
import dayjs from "dayjs";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { useDisclosure } from "@mantine/hooks";
import { BASE_API_MDM } from "../../../config";

export interface InvBalancesGtmpModel {
  organizationId?: number; // decimal?
  orgCode: string; // string
  subinventoryCode: string; // string
  inventoryItemId?: number; // decimal?
  itemCode: string; // string
  itemName: string; // string
  sltonDau?: number; // decimal?
  gttonDau?: number; // decimal?
  slNhap?: number; // decimal?
  gtNhap?: number; // decimal?
  slXuat?: number; // decimal?
  gtXuat?: number; // decimal?
  sltonCuoi?: number; // decimal?
  gttonCuoi?: number; // decimal?
}

const ChangeInformation = () => {
  let params = useParams();
  let [searchParams] = useSearchParams();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [height, setHeight] = useState(0);
  // const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<InvBalancesGtmpModel[]>([]);
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
  const [dataSaleChannel, setDataBranchCode] = useState<SelectListItemModel[]>(
    []
  );
  const [visible, { toggle, close, open }] = useDisclosure(false);

  type SearchContext = {
    keySearch?: string;
    skip?: number;
    take?: number;
    orgId?: string;
    subInvCode?: string;
    itemCode: string;
    itemName?: string;
    fromDate?: Date | null | string;
    toDate?: Date | null | string;
  };
  const [rowCount, setRowCount] = useState(0);
  const userLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}"
  );

  const form = useForm<SearchContext>({
    mode: "uncontrolled",
    initialValues: {
      orgId: userLoginHeader?.branchId?.toString() || "",
      toDate: dayjs().startOf("day").format("YYYY-MM-DDT00:00:00"),
      fromDate: dayjs().startOf("day").format("YYYY-MM-DDT00:00:00"),
    } as SearchContext,
  });

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  // Hàm lấy dữ liệu
  const fetchData = async (value: SearchContext) => {
    setIsLoading(true);
    let paginatedValue: SearchContext = {
      skip: pagination?.pageIndex * pagination?.pageSize,
      take: pagination?.pageSize,
      itemCode: "",
    };
    // if (formatDateNotTimeZone(value.toDate))
    //   paginatedValue.toDate = formatDateNotTimeZone(value.toDate);
    // if (formatDateNotTimeZone(value.fromDate))
    //   paginatedValue.fromDate = formatDateNotTimeZone(value.fromDate);
    if (value.toDate) paginatedValue.toDate = value.toDate;
    if (value.fromDate) paginatedValue.fromDate = value.fromDate;
    if (value.orgId) {
      paginatedValue.orgId = value.orgId;
    }
    if (value.subInvCode) {
      paginatedValue.subInvCode = value.subInvCode;
    }
    if (value.itemCode) {
      paginatedValue.itemCode = value.itemCode;
    }
    if (value.itemName) {
      paginatedValue.itemName = value.itemName;
    }

    const queryString = new URLSearchParams(paginatedValue as any).toString();

    try {
      const response = await repositoryMdm.get<
        MessageResponse<InvBalancesGtmpModel[]>
      >(`/api/v1/SalesReport/get-list-inv_balance-report?${queryString}`);
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      }
    } catch (error) {
      setData([]);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchData(form.getValues());
  // }, [pagination]);

  const exportDataExcel = async () => {
    try {
      open();
      const value = form.getValues();
      let paginatedValue: SearchContext = {
        skip: pagination?.pageIndex * pagination?.pageSize,
        take: pagination?.pageSize,
        itemCode: "",
      };
      // if (formatDateNotTimeZone(value.toDate))
      //   paginatedValue.toDate = formatDateNotTimeZone(value.toDate);
      // if (formatDateNotTimeZone(value.fromDate))
      //   paginatedValue.fromDate = formatDateNotTimeZone(value.fromDate);
      if (value.toDate) paginatedValue.toDate = value.toDate;
      if (value.fromDate) paginatedValue.fromDate = value.fromDate;
      if (value.orgId) {
        paginatedValue.orgId = value.orgId;
      }
      if (value.subInvCode) {
        paginatedValue.subInvCode = value.subInvCode;
      }
      if (value.itemCode) {
        paginatedValue.itemCode = value.itemCode;
      }
      if (value.itemName) {
        paginatedValue.itemName = value.itemName;
      }

      const queryString = new URLSearchParams(paginatedValue as any).toString();

      // Xây dựng URL API cuối cùng
      const baseUrl = `/api/v1/ExportExcel/export-inv-balances-gtmp?${queryString}`;
      const _url = BASE_API_MDM + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "bao_cao_nhap_xuat_ton.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.log("Error exporting data:", error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    const run = async () => {
      await DataBrachCode();
      await fetchData(form.getValues());
    };
    run();
  }, []);

  useEffect(() => {
    let tab = false;
    const getItem = searchParams.get("itemcode");
    if (getItem) {
      form.setFieldValue("itemCode", getItem);
      DataItemCode(form.getValues().itemCode || "");
      tab = true;
    }
    const getsubInvCode = searchParams.get("subInvCode");
    if (getsubInvCode) {
      form.setFieldValue("subInvCode", getsubInvCode);
      DataInvCode();
      tab = true;
    }
    const getOrgId = searchParams.get("orgId");
    if (getOrgId) {
      form.setFieldValue("orgId", getOrgId.toString());
      tab = true;
    }
    const getFromDate = searchParams.get("fromDate");
    if (getFromDate) {
      form.setFieldValue("fromDate", new Date(getFromDate));
      tab = true;
    }
    const getToDate = searchParams.get("toDate");
    if (getToDate) {
      form.setFieldValue("toDate", new Date(getToDate));
      tab = true;
    }
    if (tab) {
      fetchData(form.getValues());
    }
  }, []);

  // Lấy danh sách Kho
  const DataInvCode = async () => {
    try {
      if (form.getValues().orgId) {
        const response = await repositoryPos.get(
          `/api/v1/TblDmInventory/get-select-by-branch?branchId=${
            form.getValues().orgId
          }`
        );
        if (response && response.success) {
          const transformedData = response.data.map((item: any) => ({
            value: String(item.inventoryCode),
            label: item.inventoryCode + " - " + item.inventoryName,
          }));
          setDataInvCode(transformedData);
        } else {
          setDataInvCode([]);
        }
      } else {
        const response = await repositoryPos.get(
          `/api/v1/TblDmInventory/get-all?checkAuth=true`
        );
        if (response && response.httpStatusCode === 200) {
          const transformedData = response.data
            .filter((i: any) => i.value && i.text)
            .map((item: any) => {
              return {
                value: item.att1,
                label: item.text,
              };
            });

          setDataInvCode(transformedData);
        }
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  // Lấy danh sách chi nhánh
  const DataBrachCode = async () => {
    try {
      const response = await repositoryPos.get(
        `api/v1/TblDmInventory/get-select-branch?auth=true`
      );
      if (response && response.success) {
        const transformedData = response.data
          .filter((i: any) => i.value && i.text)
          .map((item: any) => {
            return {
              value: item.value,
              label: item.att2 + " - " + item.text,
            };
          });

        setDataBranchCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  // Call lấy list sp
  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      // const response = await repositoryDelivery.get(
      //   `api/v1/TblInventorySerialOnhand/get-list-item-by-inv?Skip=0&Take=50` +
      //     url
      // );
      const response = await repositoryPos.get(
        `api/v1/tblitem/get-select?key=${keySearch}&page=25` + url
      );
      if (response && response.success) {
        const transformedData = response.data.map((branch: any) => ({
          // value: branch.maSp,
          // label: branch.maSp + " - " + branch.tenSp,
          value: branch.value,
          label: branch.text,
        }));
        // const uniqueData = Array.from(
        //   new Set(transformedData.map((item: any) => item.value))
        // ).map((value) =>
        //   transformedData.find((item: any) => item.value === value)
        // );
        setDataItemCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  useEffect(() => {
    if (form.getValues().itemCode?.length > 3) {
      setTimeout(() => {
        DataItemCode(form.getValues().itemCode);
      }, 500);
    }
  }, [form.getValues().itemCode]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  //#region  ag -grid
  ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    AllCommunityModule,
  ]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (350 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const gridRef = useRef<AgGridReact<InvBalancesGtmpModel>>(null);
  const containerStyle = useMemo(
    () => ({ width: "100%", height: height, marginTop: "15px" }),
    [height]
  );
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const [rowData, setRowData] = useState<InvBalancesGtmpModel[]>([]);
  const columnDefs = useMemo<ColDef<InvBalancesGtmpModel>[]>(
    () => [
      {
        field: "organizationId",
        headerName: "Mã tổ chức",
        filter: "agNumberColumnFilter",
        width: 150,
      },
      {
        field: "orgCode",
        headerName: "Mã chi nhánh",
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        field: "subinventoryCode",
        headerName: "Mã kho",
        filter: "agTextColumnFilter",
        width: 100,
      },
      {
        field: "itemCode",
        headerName: "Mã sản phẩm",
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        field: "itemName",
        headerName: "Tên sản phẩm",
        filter: "agTextColumnFilter",
        width: 500,
      },
      {
        field: "sltonDau",
        headerName: "Số lượng tồn đầu",
        filter: "agNumberColumnFilter",
        width: 200,
      },
      {
        field: "gttonDau",
        headerName: "Giá trị tồn đầu",
        filter: "agNumberColumnFilter",
        width: 150,
        cellRenderer: (
          params: CustomCellRendererProps<InvBalancesGtmpModel>
        ) => <>{formatCurrencyVND(params.value) || 0}</>,
      },
      {
        field: "slNhap",
        headerName: "Số lượng nhập",
        filter: "agNumberColumnFilter",
        width: 150,
      },
      {
        field: "gtNhap",
        headerName: "Giá trị nhập",
        filter: "agNumberColumnFilter",
        width: 150,
        cellRenderer: (
          params: CustomCellRendererProps<InvBalancesGtmpModel>
        ) => <>{formatCurrencyVND(params.value) || 0}</>,
      },
      {
        field: "slXuat",
        headerName: "Số lượng xuất",
        filter: "agNumberColumnFilter",
        width: 150,
      },
      {
        field: "gtXuat",
        headerName: "Giá trị xuất",
        filter: "agNumberColumnFilter",
        width: 150,
        cellRenderer: (
          params: CustomCellRendererProps<InvBalancesGtmpModel>
        ) => <>{formatCurrencyVND(params.value) || 0}</>,
      },
      {
        field: "sltonCuoi",
        headerName: "Số lượng tồn cuối",
        filter: "agNumberColumnFilter",
        width: 150,
      },
      {
        field: "gttonCuoi",
        headerName: "Giá trị tồn cuối",
        filter: "agNumberColumnFilter",
        width: 150,
        cellRenderer: (
          params: CustomCellRendererProps<InvBalancesGtmpModel>
        ) => <>{formatCurrencyVND(params.value) || 0}</>,
      },
    ],
    [rowData]
  );

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      editable: false,
      filter: true,
      floatingFilter: true,
    };
  }, []);

  const rowSelection = useMemo<
    RowSelectionOptions | "single" | "multiple"
  >(() => {
    return { mode: "multiRow" };
  }, []);

  const statusBar = useMemo<{
    statusPanels: StatusPanelDef[];
  }>(() => {
    return {
      statusPanels: [
        { statusPanel: "agTotalAndFilteredRowCountComponent" },
        { statusPanel: "agTotalRowCountComponent" },
        { statusPanel: "agFilteredRowCountComponent" },
        { statusPanel: "agSelectedRowCountComponent" },
        { statusPanel: "agAggregationComponent" },
      ],
    };
  }, []);

  const onGridReady = useCallback(async (params: GridReadyEvent) => {
    // const date = new Date();
    // form.setFieldValue("fromDate", formatDateNotTimeZone(date) || "");
    // form.setFieldValue("toDate", formatDateNotTimeZone(date) || "");

    await fetchData(form.getValues());
  }, []);

  const getContextMenuItems = useCallback(
    (
      params: GetContextMenuItemsParams<InvBalancesGtmpModel>
    ): (DefaultMenuItem | MenuItemDef)[] => {
      const _number = params?.node?.data?.itemCode || "";
      const _kho = form.getValues().subInvCode || "";
      const _chinhanh = form.getValues().orgId || "";
      const _from = form.getValues().fromDate || "";
      const _to = form.getValues().toDate || "";
      var result: (DefaultMenuItem | MenuItemDef)[] = [
        {
          name:
            "Xem báo cáo liệt kế giao dịch nhập/xuất " +
            params?.node?.data?.itemCode +
            " (tab mới)",
          action: () => {
            //  handleAddProduct(false);
            window.open(
              `/warehouse-config/inventoryTransfer?itemcode=${_number}&subInvCode=${_kho}&orgId=${_chinhanh}&fromDate=${_from}&toDate=${_to}`
            );
          },
          cssClasses: ["red", "bold"],
        },
        "cut",
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
        "paste",
        "separator",
        "chartRange",
        "export",
      ];
      return result;
    },
    [window, rowData]
  );

  //#endregion
  return (
    // <Box>
    //   <MantineReactTable table={table} />
    // </Box>
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />

      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Group justify="space-between">
          <_breadcrumb></_breadcrumb>

          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Group>
        <Box
          mt={10}
          component="form"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
          onSubmit={form.onSubmit(async (e: any) => {
            await fetchData(e);
          })}
        >
          <Input
            style={{
              flex: 1,
              maxWidth: "180px",
              minWidth: "180px",
              display: "none",
            }}
            key={form.key("keySearch")}
            placeholder="Nhập tìm kiếm"
            type="text"
            leftSection={<IconSearch size={"20"} color="#15aabf" />}
            {...form.getInputProps("keySearch")}
          />
          <Select
            key={`${form.getValues().orgId}`}
            placeholder="Chọn chi nhánh"
            data={dataSaleChannel}
            leftSection={<IconBuildingSkyscraper size={20} color="#15aabf" />}
            clearable
            searchable
            value={dataSaleChannel.length > 0 ? form.getValues().orgId : ""}
            // {...form.getInputProps("orgId")}
            onChange={async (e, value) => {
              form.setFieldValue("orgId", e ? e.toString() : "");
              await DataInvCode();
            }}
            // value={
            //   form.getValues().orgId ? form.getValues().orgId?.toString() : ""
            // }
            // onChange={(e) =>
            //   form.setValues((prev) => ({ ...prev, orgId: e ? e : "" }))
            // }
          />
          <Select
            id="subInvCode"
            key={form.key("subInvCode")}
            placeholder="Chọn kho"
            data={dataInvCode}
            leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
            clearable
            searchable
            {...form.getInputProps("subInvCode")}
            onClick={() => {
              if (dataInvCode.length === 0) {
                DataInvCode();
              }
            }}
          />
          <DatePickerInput
            size="sm"
            key={form.key("fromDate")}
            placeholder="Chọn ngày bắt đầu"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            // maxDate={new Date()}
            leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
            {...form.getInputProps("fromDate")}
            // onChange={(date) => {
            //   form.setFieldValue("fromDate", formatDateNotTimeZone(date) || "");
            // }}
            value={
              form.getValues().fromDate
                ? dayjs(form.getValues().fromDate).toDate()
                : null
            }
            onChange={(date) =>
              form.setFieldValue(
                "fromDate",
                date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
              )
            }
            clearable
          />
          <DatePickerInput
            size="sm"
            key={form.key("toDate")}
            placeholder="Chọn ngày kết thúc"
            locale="vi"
            leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
            valueFormat="DD/MM/YYYY"
            // maxDate={new Date()}
            {...form.getInputProps("toDate")}
            // onChange={(date) => {
            //   form.setFieldValue("toDate", formatDateNotTimeZone(date) || "");
            // }}
            value={
              form.getValues().toDate
                ? dayjs(form.getValues().toDate).toDate()
                : null // Nếu không có giá trị, đặt null
            }
            onChange={(date) =>
              form.setFieldValue(
                "toDate",
                date
                  ? dayjs(date).startOf("day").format("YYYY-MM-DDT00:00:00")
                  : ""
              )
            }
            clearable
          />
          <Select
            key={form.key("itemCode")}
            placeholder="Chọn mã sản phẩm"
            data={dataItemCode}
            leftSection={<IconBarcode size={20} color="#15aabf" />}
            value={
              form.getValues().itemCode
                ? form.getValues().itemCode?.toString()
                : ""
            }
            clearable
            searchable
            onChange={(e) =>
              form.setValues((prev) => ({ ...prev, itemCode: e ? e : "" }))
            }
            onSearchChange={(value) => {
              // if (value.length >= 3 && form.getValues().itemCode === "") {
              //   DataItemCode(value);
              //   form.setValues((prev) => ({ ...prev, itemName: value }));
              // } else if (
              //   form.getValues().itemCode?.length > 0 &&
              //   value === form.getValues().itemName
              // ) {
              //   DataItemCode(form.getValues().itemCode);
              // } else if (
              //   form.getValues().itemCode?.length > 0 &&
              //   value !== form.getValues().itemName
              // ) {
              //   DataItemCode(value);
              //   form.setValues((prev) => ({ ...prev, itemName: value }));
              // }
              // else
              // {
              //   DataItemCode(value);
              //   form.setValues((prev) => ({ ...prev, itemName: value }));
              // }
              if (value.length >= 3) {
                DataItemCode(value);
              }
            }}
          />
          <Button color="blue" variant="outline" type="submit">
            Tìm kiếm
          </Button>
        </Box>
      </div>

      <div style={containerStyle}>
        <div style={gridStyle} className={"ag-theme-quartz"}>
          <AgGridReact<InvBalancesGtmpModel>
            ref={gridRef}
            rowData={data}
            theme={baseTheme}
            loading={isLoading}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            suppressColumnVirtualisation={true}
            suppressRowVirtualisation={true}
            pagination={true}
            localeText={AG_GRID_LOCALE_VN}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
            cacheBlockSize={paginationPageSize}
            maxBlocksInCache={3}
            rowSelection={undefined}
            statusBar={statusBar}
            getContextMenuItems={getContextMenuItems}
            cellSelection={true}
            //  onGridReady={onGridReady}
          />
        </div>
      </div>
    </Box>
  );
};

export default ChangeInformation;
